import { render, staticRenderFns } from "./PurchaseInvoiceCreateView.vue?vue&type=template&id=4068038a"
import script from "./PurchaseInvoiceCreateView.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports